// extracted by mini-css-extract-plugin
module.exports = {"PartnerName":"PartnerListTableBody_PartnerName__F_LA8"};